/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AIGovernanceRequest extends models.AIGovernanceRequestBase {
    getFixupPrototypeFunction() { return AIGovernanceRequest.fixupPrototype; }

    static newInstance(model: Partial<AIGovernanceRequest>): AIGovernanceRequest {
        let obj = Object.assign(new AIGovernanceRequest(), model);
        AIGovernanceRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AIGovernanceRequest>): AIGovernanceRequest {
        if (!model) return null;
        return AIGovernanceRequest.newInstance(<AIGovernanceRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AIGovernanceRequest) {
        if (!obj) return;

        models.AIGovernanceRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AIGovernanceRequest): boolean {
        if (models.AIGovernanceRequestBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AIGovernanceRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Search term to be matched against the prompt, model, provider, region, and ID.
     */
    search: string;

}
